<div class="layout-padding mx-auto h-full max-h-[90vh] max-w-screen-2xl">
  @if (store.loading$ | async) {
    <mat-progress-bar mode="indeterminate" />
  }

  @if (store.referral$ | async; as referral) {
    <pr-content-container height="h-full" overflow="overflow-hidden">
      <div class="flex h-full flex-col gap-4">
        <pr-referral-toolbar [referral]="referral">
          <button
            ngProjectAs="referral-dashboard"
            mat-icon-button
            matTooltip="Back to Dashboard"
            [routerLink]="['/referrals']"
          >
            <mat-icon>arrow_back</mat-icon>
          </button>
        </pr-referral-toolbar>

        <mat-tab-group
          class="flex-1"
          mat-align-tabs="start"
          mat-stretch-tabs="false"
          fitInkBarToContent
        >
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2 text-sm text-black">
                <mat-icon class="icon-sm">chat</mat-icon> Messages
              </span>
            </ng-template>
            <pr-referral-image-upload
              [referral]="referral"
              [currentUser]="store.currentUser$ | async"
            >
              <pr-referral-communication
                [referral]="referral"
                [menuItems]="menuItems()"
                [messages]="store.messages$ | async"
                [interactions]="store.interactions$ | async"
                [media]="store.media$ | async"
                [clinicalNotes]="store.clinicalNotes$ | async"
                [currentUser]="store.currentUser$ | async"
              >
                <pr-referral-attachment-menu
                  ngProjectAs="attach-file"
                  [uploadFileOnly]="true"
                  [referral]="store.referral$ | async"
                  [patient]="store.patient$ | async"
                  [currentUser]="store.currentUser$ | async"
                />
              </pr-referral-communication>
            </pr-referral-image-upload>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2 text-sm text-black">
                <mat-icon class="icon-sm">attach_file</mat-icon> Files
              </span>
            </ng-template>
            <pr-referral-image-upload
              [referral]="referral"
              [currentUser]="store.currentUser$ | async"
            >
              <pr-referral-media
                [referral]="referral"
                [media]="store.media$ | async"
                [currentUser]="store.currentUser$ | async"
              >
                <pr-referral-attachment-menu
                  ngProjectAs="attach-file"
                  [uploadFileOnly]="true"
                  [referral]="store.referral$ | async"
                  [patient]="store.patient$ | async"
                  [currentUser]="store.currentUser$ | async"
                />
                <pr-referral-attachment-menu
                  ngProjectAs="empty-state"
                  layout="expanded"
                  [uploadFileOnly]="true"
                  [referral]="store.referral$ | async"
                  [patient]="store.patient$ | async"
                  [currentUser]="store.currentUser$ | async"
                />
              </pr-referral-media>
            </pr-referral-image-upload>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <span class="flex items-center gap-2 text-sm text-black">
                <mat-icon class="icon-sm">info</mat-icon> Information
              </span>
            </ng-template>

            <div class="flex flex-col gap-4 p-4">
              <pr-referral-patient-details
                [editable]="false"
                [referral]="referral"
                [title]="'Patient Information'"
              />

              <pr-referral-participant-details
                [contactDetails]="referral.stafferDetails"
                [practiceName]="referral.practice.name"
                [title]="'Referrer Details'"
                [editable]="false"
              />
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </pr-content-container>
  } @else if (store.referralUnavailable$ | async) {
    <pr-referral-portal-access-issue
      [email]="signedInEmail()"
      [expectedEmail]="expectedEmail()"
      (switchAccount)="switchAccount()"
    />
  }
</div>
